import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTheme } from '../../ThemeContext'
import { useSession } from '../../Controllers/useSession'
import Sidebar from '../Sidebar/Sidebar'
import Header  from '../Header/Header'

export default function MainLayout() {
  const [mobileOpen, setMobileOpen]   = useState(false)
  const [collapsed,  setCollapsed]    = useState(false)
  const { theme, setTheme } = useTheme()
  const isAuth = useSelector((state) => state.auth.isAuth)
  const session = useSession(isAuth)

  if (!isAuth || session.isExpired) {
    return <Navigate to="/" replace />
  }

  return (
    <>
      <div className="layout-root" data-theme={theme}>
        <Sidebar
          mobileOpen={mobileOpen}
          onClose={() => setMobileOpen(false)}
          collapsed={collapsed}
          onToggle={() => setCollapsed(c => !c)}
        />
        <div className={`layout-body${collapsed ? ' layout-body--collapsed' : ''}`}>
          <Header
            onMenuOpen={() => setMobileOpen(true)}
            theme={theme}
            onThemeToggle={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          />
          <main className="layout-main">
            <div className="page-in">
              <Outlet context={session} />
            </div>
          </main>
        </div>
      </div>

      <style>{`
        /* Root: full viewport, no overflow */
        .layout-root {
          display: flex;
          height: 100vh;
          overflow: hidden;
          background: var(--bg-base);
        }

        /* layout-body: fills remaining width, column flex, fixed height */
        .layout-body {
          margin-left: var(--sidebar-width);
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 100vh;
          min-width: 0;
          transition: margin-left var(--ease-slow);
        }
        .layout-body--collapsed {
          margin-left: var(--sidebar-collapsed-width);
        }

        /* Header: fixed height, never scrolls */
        /* (Header component itself handles this via var(--header-height)) */

        /* Main: takes remaining height and scrolls independently */
        .layout-main {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding: var(--space-lg);
        }

        /* Sidebar already has position:fixed + overflow-y:auto in Sidebar.jsx */

        @media (max-width: 768px) {
          .layout-body,
          .layout-body--collapsed {
            margin-left: 0 !important;
          }
          .layout-main {
            padding: var(--space-md);
          }
        }
      `}</style>
    </>
  )
}